import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "../../GenericTableResponse";

export class ServiceTypeGroup {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  displayedName!: string;
  @Expose()
  @IsNumber()
  recordStampId!: number;
}

export class ServiceTypeGroups extends GenericTableResponse<ServiceTypeGroup> {
  @Expose()
  @Type(() => ServiceTypeGroup)
  @IsArray()
  @ValidateNested()
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  items!: Array<ServiceTypeGroupItem>;
}
